"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var isMatch_1 = __importDefault(require("lodash/isMatch"));
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var PaginationActionComponent_1 = __importDefault(require("../../../../../app/components/widgets/PaginationActionComponent"));
var styles_1 = __importDefault(require("./styles"));
var AppMargins_1 = require("../../../../../app/components/AppMargins");
// Prevents re-render if pagination did not change.
var paginationInputIsEqual = function (prev, next) {
    return prev.tableConfig.numberOfRows === next.tableConfig.numberOfRows &&
        prev.tableConfig.pageNumber === next.tableConfig.pageNumber &&
        prev.urlCount === next.urlCount;
};
var MemoTablePagination = react_1.default.memo(function (_a) {
    var urlCount = _a.urlCount, tableConfig = _a.tableConfig, updateUrlTableConfig = _a.updateUrlTableConfig;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var appMargins = appMargins_1.default();
    var classes = styles_1.default({ appMargins: appMargins });
    var updateTableIfChanged = function (newConfig) {
        if (!isMatch_1.default(tableConfig, newConfig)) {
            updateUrlTableConfig(newConfig);
        }
    };
    var changePageHandler = function (_, pageNumber) {
        updateTableIfChanged({ pageNumber: pageNumber });
    };
    var changeRowsPerPageHandler = function (event) {
        updateTableIfChanged({
            numberOfRows: Number(event.target.value),
            pageNumber: 0,
        });
    };
    var pageCount = Math.ceil(urlCount / tableConfig.numberOfRows);
    return (react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
        react_1.default.createElement(core_1.Paper, { elevation: 0, className: classes.paperTable },
            react_1.default.createElement(core_1.TablePagination, { ActionsComponent: function (_a) {
                    var onPageChange = _a.onPageChange, page = _a.page;
                    return (react_1.default.createElement(PaginationActionComponent_1.default, { pageCount: pageCount, onChangePage: onPageChange, page: page }));
                }, labelRowsPerPage: t('text.linksPerPage'), rowsPerPageOptions: [10, 25, 100], component: "div", count: urlCount, rowsPerPage: tableConfig.numberOfRows, page: tableConfig.pageNumber, backIconButtonProps: {
                    'aria-label': 'previous page',
                }, nextIconButtonProps: {
                    'aria-label': 'next page',
                }, onPageChange: changePageHandler, onChangeRowsPerPage: changeRowsPerPageHandler, classes: {
                    spacer: classes.spacer,
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                    select: classes.select,
                    selectIcon: classes.selectIcon,
                } }))));
}, paginationInputIsEqual);
exports.default = MemoTablePagination;
